import { history } from 'helpers';
import { getAccessToken, getCookie } from 'helpers/utis';
import PropTypes from 'prop-types';
import { useCallback, useEffect } from 'react';
import './authlayout.scss';
import routers from 'routes/routes';

// Pages reachable via email links even if a stale session is still stored
const GUARD_EXEMPT_PATHS = ['/auth/reset-password'];

const isGuardExempt = () =>
  GUARD_EXEMPT_PATHS.includes(window.location.pathname);

export function AuthLayout(props) {
  const { children } = props;

  const websiteGuard = useCallback(() => {
    if (isGuardExempt()) return;
    if (getCookie('token')) history.push('/dashboard');
  }, []);

  useEffect(() => {
    websiteGuard();
  });

  useEffect(() => {
    if (isGuardExempt()) return;
    const token = getAccessToken();
    if (token) {
      const userData = JSON.parse(localStorage.getItem('userData'));
      const role = userData?.roles;
      const isOnlyCad = role?.length === 1 && role?.[0] === 'cad';
      const isOnlyPartner = role?.length === 1 && role?.[0] === 'partner';
      if (isOnlyCad) {
        history.push('/home/reports');
      } else if (isOnlyPartner) {
        history.push('/home/partner-recommendation');
      } else {
        history.push('/home/manage-products');
      }
    }
  }, []);

  useEffect(() => {
    const currentUrl = window.location.pathname;
    const isUrlValid = routers.some((route) => {
      if (route.childrens) {
        return route.childrens.some((childRoute) => {
          const fullPath = route.path + childRoute.path;
          return fullPath === currentUrl;
        });
      }
      return false;
    });
    if (!isUrlValid) {
      // history.push('/404');
    }
  }, [window.location.pathname]);

  return (
    <>
      <div className="auth-content-wrapper">{children}</div>
    </>
  );
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
};
